const testimonials = [
  {
    name: "Cpt. James B.",
    location: "O'Fallon, MO",
    stars: 5,
    text: "PCS orders came in with 3 weeks notice. Fast Passport Center had my wife and kids' passports renewed in under 72 hours. Scott AFB families — this is your service.",
    role: "Military family",
  },
  {
    name: "Michelle S.",
    location: "Lake Saint Louis, MO",
    stars: 5,
    text: "Tech conference in Amsterdam and my passport was expired. The STL agency had no emergency slots. Fast Passport Center saved my trip — and my presentation.",
    role: "IT project manager",
  },
  {
    name: "Ryan & Amy P.",
    location: "St. Charles, MO",
    stars: 5,
    text: "Last-minute Cancún family trip — my daughter's passport had expired. Within 3 days, new passport arrived. Zero stress, 100% professional. Highly recommend.",
    role: "Family vacationers",
  },
  {
    name: "Dr. Lisa N.",
    location: "Wentzville, MO",
    stars: 5,
    text: "Medical conference in London every year. Fast Passport Center handles my renewal every time my passport gets within 6 months of expiry. Never missed a trip.",
    role: "Healthcare professional",
  },
];

export default function OFallonTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Real Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What O&apos;Fallon &amp; St. Charles County Travelers Say
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-0.5 mb-3">
                {Array(t.stars).fill(null).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <span className="text-white font-bold text-sm">{t.name[0]}</span>
                </div>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location} &middot; {t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}